import { Directive, ElementRef, EventEmitter, Input, Output, OnInit, OnDestroy } from '@angular/core';
import { UploadOutput, UploadInput, UploaderOptions } from '../model/index';
import { FFileUploaderService } from '../service/index';
import { Subscription } from 'rxjs';

@Directive({
    selector: '[FFileDrop]'
})
export class FFileDropDirective implements OnInit, OnDestroy {
    private tDisabled = false;
    // 是否禁用
    @Input()
    set disabled(value: boolean) {
        if (this.tDisabled !== value) {
            this.tDisabled = value;
            if (value) {
                this.unbindDragAndDropEvent();
            } else {
                this.bindDragAndDropEvent();
            }
        }
    };
    get disabled(): boolean {
        return this.tDisabled;
    }
    // 配置
    @Input()
    set options(value: UploaderOptions) {
        this.upload.setOptions(value);
    };
    // 已上传
    @Input()
    set uploadedCount(value){
        this.upload.setOptions({'uploadedCount':value});
    }
    // 传递
    @Input() uploadInput: EventEmitter<UploadInput>;
    @Output() uploadOutput: EventEmitter<UploadOutput>;

    //upload: FFileUploaderService;
    el: HTMLInputElement;

    _sub: Subscription[];

    // eventListener
    dropListener: any = null;
    dragOverListener: any = null;
    dragLeaveListener: any = null;
    dragEnterListener: any = null;

    constructor(public elementRef: ElementRef, private upload: FFileUploaderService) {
        this.uploadOutput = new EventEmitter<UploadOutput>();
    }

    ngOnInit() {
        this._sub = [];
        this.el = this.elementRef.nativeElement;

        this._sub.push(
            this.upload.serviceEvents.subscribe((event: UploadOutput) => {
                this.uploadOutput.emit(event);
            })
        );

        if (this.uploadInput instanceof EventEmitter) {
            this._sub.push(this.upload.initInputEvents(this.uploadInput));
        }
        // 绑定事件
        if (!this.disabled) {
            this.bindDragAndDropEvent();
        }
    }

    ngOnDestroy() {
        this.unbindDragAndDropEvent();
        this._sub.forEach(sub => sub.unsubscribe());
    }
    private bindDragAndDropEvent() {
        // this.ngzone.runOutsideAngular(() => {
        this.dropListener = this.onDrop.bind(this);
        this.el.addEventListener('drop', this.dropListener);
        this.dragOverListener = this.onDragOver.bind(this);
        this.el.addEventListener('dragover', this.dragOverListener);
        this.dragLeaveListener = this.onDragLeave.bind(this);
        this.el.addEventListener('dragleave', this.dragLeaveListener);
        this.dragEnterListener = this.onDropEnter.bind(this);
        this.el.addEventListener('dragenter', this.dragEnterListener);
        //  });
    }
    private unbindDragAndDropEvent() {
        this.dropListener && this.el.removeEventListener('drop', this.dropListener);
        this.dragOverListener && this.el.removeEventListener('dragover', this.dragOverListener);
        this.dragLeaveListener && this.el.removeEventListener('dragleave', this.dragLeaveListener);
        this.dragEnterListener && this.el.removeEventListener('dragenter', this.dragEnterListener);
    }

    onDropEnter = (e: Event) => {
        e.stopPropagation();
        e.preventDefault();
    }


    // @HostListener('drop', ['$event'])
    public onDrop(e) {
        e.stopPropagation();
        e.preventDefault();
        const event: UploadOutput = { type: 'drop' };
        // console.log('dorp Events');
        this.uploadOutput.emit(event);
        this.upload.handleFiles(e.dataTransfer.files);
    }

    // @HostListener('dragover', ['$event'])
    public onDragOver(e: Event) {
        if (!e) {
            return;
        }
        e.stopPropagation();
        e.preventDefault();
        const event: UploadOutput = { type: 'dragOver' };
        this.uploadOutput.emit(event);
    }

    // @HostListener('dragleave', ['$event'])
    public onDragLeave(e: Event) {
        if (!e) {
            return;
        }
        e.stopPropagation();
        e.preventDefault();
        const event: UploadOutput = { type: 'dragOut' };
        this.uploadOutput.emit(event);
    }
    /**
     * 重置
     */
    reset() {
       /*if (this.el) {
            this._sub.forEach(sub => sub.unsubscribe());
            this._sub = [];
            this.upload.reset();
        }*/
        this.upload.reset();
    }
}
